import React, { useEffect, useState, useRef } from 'react';
import { Row, Col, Table, Spinner, Form, Button } from 'react-bootstrap';
import moment from 'moment';
import generatePDF, { Resolution, Margin } from 'react-to-pdf';
import * as XLSX from 'xlsx';
import * as Icon from 'react-bootstrap-icons';
import { useSelector } from 'react-redux';

const GatTotalCalling = () => {
    const userState = useSelector(state => state.loginData.userData);
    const financialYear = useSelector(state => state.activeData.activeMenu.activeTab);
    const activeKey = useSelector((state) => state.activeData?.activeNumberKey?.activeKey);

    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState()
    const Zoneoptions = {
        page: {
            margin: 10,
        },
        filename: 'Gat Wise Calling.pdf'
    };

    const [zoneLoader, setZoneLoader] = useState(false);
    const [zoneWiseCalling, setZoneWiseCalling] = useState('');
    const [date, setDate] = useState('');

    const zoneWiseTarget = useRef();
    useEffect(() => {
        getZoneWiseTotalCalling();
    }, [startDate, endDate])
    // /tc/zoneWiseReport "9921623625"
    const getZoneWiseTotalCalling = async () => {
        setZoneLoader(true);
        await fetch(process.env.REACT_APP_BASE_URL + '/user/getCombinedCallingForUser', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                // zonename: userState?.zonename,
                callingDate: date,
                startDate: "",
                endDate: "",
                financialYear: "",
                mobile: userState?.contactNo,
                fromDate:startDate,
                toDate:endDate
            })
        }).then((res) => res.json()).then((response) => {
            setZoneWiseCalling(response?.data);
            setZoneLoader(false);
        }).catch((Err) => {
            console.log("Err while getting Gat Wise calling", Err);
            setZoneLoader(false);
        })
    }
const downloadExcel = (data, tableRef) => {
  // Get the table element from the ref
  const table = tableRef.current;
  
  // If we have direct data (zoneWiseCalling), use that
  if (data && Array.isArray(data) && data.length > 0) {
    const excelData = data.map((row, index) => ({
      'Sr. No': index + 1,
      'Name': row?.name || '',
      'Mobile': row?.contactNo || '',
      'Zone': (row?.zonename && row?.zoneno) ? `${row.zonename}-${row.zoneno}` : '',
      'Gat': Array.isArray(row?.gatname) ? row.gatname.join(', ') : '',
      'Role': row?.usertype_name[0] || '',
      'Calling Count': row?.callingCount || 0,
      'Talk Duration': row?.talkDuration || ''
    }));

    const ws = XLSX.utils.json_to_sheet(excelData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "UserWise Data");
    XLSX.writeFile(wb, "UserWise_Report.xlsx");
  } 
  // If we need to extract data from the table HTML
  else if (table) {
    const ws = XLSX.utils.table_to_sheet(table);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "UserWise Data");
    XLSX.writeFile(wb, "UserWise_Report.xlsx");
  } else {
    console.error("No data available for Excel export");
  }
};
    return (
        <div className='TotalCalling mb-5'>
            <Row className='justify-content-between align-items-center'>
                <Col md={4} className='d-flex mb-3 mb-md-0'>
                    <div className='me-3'>
                        <Form.Label>Search by Start date</Form.Label>
                        <Form.Control type="date" value={startDate} max={new Date().toISOString().split("T")[0]} onChange={(e) => setStartDate(moment(e.target.value).format("YYYY-MM-DD"))} />
                    </div>
                    <div className='me-3'>
                        <Form.Label>Search by End date</Form.Label>
                        <Form.Control type="date" value={endDate} max={new Date().toISOString().split("T")[0]} onChange={(e) => setEndDate(moment(e.target.value).format("YYYY-MM-DD"))} />
                    </div>
                </Col>
                <Col md={4} className='d-flex mb-3 mb-md-0'>
                    <Button className='btn-cancel mx-auto' onClick={() =>downloadExcel(zoneWiseCalling, zoneWiseTarget)}>
                        <Icon.ArrowDownCircle size={14} className='me-2' />Download UserWise Excel
                    </Button>
                </Col>
            </Row>

            <div className="container tbl-container p-0 mt-4" ref={zoneWiseTarget}>

                <div className="row tbl-fixedd p-0">
                    <Table responsive="lg" hover>
                        <thead>
                            <tr>
                                <th>Sr.</th>
                                <th>Name</th>
                                <th>Mobile</th>
                                <th>Zone</th>
                                <th>Gat</th>
                                <th>Role</th>
                                <th>Calling Count</th>
                                <th>Talk Duration</th>
                            </tr>
                        </thead>

                        {zoneLoader ? (
                            <Spinner variant="primary" className="mt-2" />
                        ) : (
                            <tbody>
                                {zoneWiseCalling !== null && zoneWiseCalling !== undefined && zoneWiseCalling.length > 0
                                    ? zoneWiseCalling.map((row, index) => {
                                        return (
                                            <tr>
                                                <td>{index + 1}</td>
                                                <td style={{ whiteSpace: 'nowrap' }}>{row?.name}</td>
                                                <td>{row?.contactNo}</td>
                                                <td style={{ whiteSpace: 'nowrap' }}>{row?.zonename + '-' + row?.zoneno}</td>
                                                <td style={{ maxWidth: '150px', wordWrap: 'break-word' }}>{row?.gatname.map((row) => row).join(', ')}</td>
                                                <td>{row?.usertype_name}</td>
                                                <td>{row?.callingCount}</td>
                                                <td>{row?.talkDuration}</td>
                                            </tr>
                                        );
                                    })
                                    : "No calling data found"}
                            </tbody>
                        )}
                    </Table>
                </div>
            </div >
        </div>
    )
}

export default GatTotalCalling;